module.exports = __webpack_public_path__ + "img/pt-3-dub.694390de.jpg";